import { nullable, partial, record, string, struct, union, UnknownRecord } from 'io-ts/Decoder';

import { Type as AddressType } from '../../../../address/Type';
import { NewRefItem as NewBuilderRefItem } from '../../../../builder/NewRefItem';
import { NewRefItem as NewCustomerRefItem } from '../../../../customer/NewRefItem';
import { Id as JobTypeId } from '../../../../job/job-type';
import { Id as RequestTypeId } from '../../../../job/request-type';
import { NewRefItem as NewProjectRefItem } from '../../../../project/NewRefItem';
import { Datetime } from '../../../../time/Datetime';
import { Id as UserId } from '../../../../user/Id';

/** @deprecated use DatetimeField instead */
const LegacyDatetime = nullable(string);
const DatetimeField = nullable(Datetime);
const LegacyOrNewDatetime = union(LegacyDatetime, DatetimeField);

export const Request = partial({
	jobName: string,
	jobRef: nullable(string),
	//
	builder: nullable(NewBuilderRefItem),
	project: nullable(NewProjectRefItem),
	customer: nullable(NewCustomerRefItem),
	//
	timeline: record(LegacyOrNewDatetime),
	//
	siteAddress: nullable(AddressType),
	//
	bedcDifficultyRating: nullable(string),
	internalDifficultyRating: nullable(string),
	//
	customFormData: nullable(UnknownRecord),
	notes: nullable(string),
	//
	jobType: JobTypeId,
	requestType: RequestTypeId,
	//
	team: partial({
		salesPerson: nullable(
			struct({
				id: nullable(UserId),
			})
		),
		customerContact: nullable(
			struct({
				id: nullable(UserId),
			})
		),
	}),
});
